import memoize from "memoize-one";
import {createMapKey} from "../../utils";
import RouteResponsePoint from "../../models/RouteResponsePoint";

const getRouteBounds = points => {
  if (points.length === 0) {
    return undefined;
  }

  const bounds = {
    xLowest: points[0].lat,
    xHighest: points[0].lat,
    yLowest: points[0].lon,
    yHighest: points[0].lon,
  };

  for (let i = 1; i < points.length; i += 1) {
    const point = points[i];

    if (point.lat > bounds.xHighest) bounds.xHighest = point.lat;
    if (point.lat < bounds.xLowest) bounds.xLowest = point.lat;
    if (point.lon > bounds.yHighest) bounds.yHighest = point.lon;
    if (point.lon < bounds.yLowest) bounds.yLowest = point.lon;
  }

  return [[bounds.xLowest, bounds.yLowest], [bounds.xHighest, bounds.yHighest]];
};

// Вызывать его при перетаскивании карты, чтобы не получать повторно visualRoute, если он весь отрисован на карте. 
const getMapBounds = memoize(points => getRouteBounds(points));

// {
//     "route_point": {
//         "node_types": 5,
//         "city_info": {
//             "city_id": 1,
//             "osm_city_id": 11066,
//             "name": "Санкт-Петербург",
//             "city_size": 6
//         },
//         "address": null,
//         "geoPoint": {
//             "lat": 59.93881876648482,
//             "lon": 30.31619419169246
//         },
//         "osm_region_id": 0,
//         "region": "Санкт-Петербург г",
//         "osm_country_id": 0,
//         "country": "Россия"
//     },
//     "visits":[{
//         "estimatedTimeOfArrival": "28.11.2022 13:15",
//         "totalDistance": 1387,
//         "nodeTypes": 8,
//         "passthroughIndex": undefined
//     },
//     {
//         "estimatedTimeOfArrival": "28.11.2022 19:25",
//         "totalDistance": 1517,
//         "nodeTypes": 16,
//         "passthroughIndex": 1
//     }]
// }
export const getVisitedRoutePoints = (routeSegments) => {

  let passthroughIndex = 0;
  const visitedRoutePoints = {};
  for (let i = 0; i < routeSegments.length; i++) {
    const routeSegment = routeSegments[i];
    const routePoint = routeSegment.routePoint;
    const key = createMapKey(routePoint);
    let visitedRoutePoint = visitedRoutePoints[key];
    if (!visitedRoutePoint) {
      visitedRoutePoint = {
        /** @type {RouteResponsePoint} */
        routePoint, 
        visits: []
      };
      visitedRoutePoints[key] = visitedRoutePoint;
    }
        
    const visit = {
      estimatedTimeOfArrival: routeSegment.estimatedTimeOfArrival,
      totalDistance: routeSegment.totalDistance,
      nodeTypes: routePoint.nodeTypes
    };

    const isFromPoint = i === 0;
    const isToPoint = i === routeSegments.length - 1;
    if(RouteResponsePoint.isKeyPoint(routePoint) && !isFromPoint && !isToPoint) {
      visit.passthroughIndex = passthroughIndex++;
    }

    visitedRoutePoint.visits.push(visit);
  }
  return Object.values(visitedRoutePoints);
};

export default getMapBounds;
